import cx from 'classnames';
import PropTypes from 'prop-types';

import { ButtonText } from 'src/components/ButtonText';
import { CustomTypography } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  onCtaClick: PropTypes.func.isRequired,
};

const defaultProps = {
  className: null,
};

export const DisabledBanner = ({ className, onCtaClick }) => {
  const styles = useStyles();

  return (
    <div className={cx(styles.root, className)}>
      <CustomTypography className={styles.title}>AP style compliance is </CustomTypography>
      <ButtonText
        className={styles.buttonCta}
        onClick={onCtaClick}
      >
        disabled
      </ButtonText>
      <span>.</span>
    </div>
  );
};

DisabledBanner.propTypes = propTypes;
DisabledBanner.defaultProps = defaultProps;
